import {arrayOf, number, oneOfType, shape, string, func, bool} from 'prop-types';

export const inputValue = oneOfType([number, string]).isRequired;

const option = shape({
	value: inputValue,
	label: string.isRequired
});

export const options = arrayOf(option).isRequired;

export const select = {
	option,
	options: arrayOf(option)
};

export const dropdownOption = {
	label: string,
	onClick: func,
	isDisabled: bool,
	isSelected: bool
};
